export default __webpack_public_path__ + "static/media/toinhabrasilshow-arena1.be4a0525.png";